import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../data/siteConfig';
interface LogoProps {
  onClick?: () => void;
}
export function Logo({
  onClick
}: LogoProps) {
  return <Link to="/" onClick={onClick} className="inline-flex items-center gap-3" aria-label="Qorvessa Executive Partners, home" data-id="element-155" data-mp="tb0fgaazt022">
      <img src={siteConfig.logoUrl} alt="" className="h-11 w-auto mix-blend-screen" data-id="element-156" data-mp="oc6zmb88gwyq" />
      <span className="flex flex-col leading-none" data-id="element-157" data-mp="kc6jmm5hkdpk">
        <span className="font-serif text-[22px] font-semibold tracking-[0.04em] text-champagne-100" data-id="element-158" data-mp="fketudu5mc0h">Qorvessa</span>
        <span className="mt-1 text-[9.5px] font-medium uppercase tracking-[0.3em] text-champagne-400" data-id="element-159" data-mp="al25tprjqywb">Executive Partners</span>
      </span>
    </Link>;
}